"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMultiColumnGroup;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function UIMultiColumnGroup(props) {
  var children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, other, {
    className: (0, _classNames.default)('private-multicolumn__group', className)
  }), children);
}

UIMultiColumnGroup.displayName = 'UIMultiColumnGroup';
UIMultiColumnGroup.propTypes = {
  children: _react.PropTypes.node
};
module.exports = exports.default;